<template>
	<div class="row my-4">
		<div class="col-sm-12 position-relative border border-warning py-2">
			<div class="row">
				<div class="form-group col-sm-4">
					<BaseMultiSelect
						@update:value="setRoomType"
						:options="multiSelectState.roomTypes"
						rules="required"
						:defaultData="data.type"
						:requirer="true"
						name="Room Types"
						mode="single"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>

				<div class="from-group col-sm-4">
					<BaseInput
						name="Price"
						label="Price"
						type="number"
						:min="600"
						v-model="data.price"
						class="form-control form-control-lg dashInput"
						rules="required"
						:required="true"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>
				<div class="from-group col-sm-4">
					<BaseInput
						name="Capacity"
						label="Capacity"
						type="number"
						:min="1"
						class="form-control form-control-lg dashInput"
						v-model="data.capacity"
						rules="required"
						:required="true"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>
			</div>
			<span
				v-if="count !== 0"
				@click="$emit('removeComponent', count)"
				class="mx-2 position-absolute top-100 start-100 translate-middle badge rounded-pill bg-danger cursor-pointer"
				><i class="bi bi-x"></i
			></span>
		</div>
	</div>
</template>
<script>
	import { reactive, watch } from "vue";
	import Helper from "@/helpers/dataHelper";

	import BaseInput from "./BaseInput";
	import BaseMultiSelect from "./BaseMultiSelect";

	export default {
		name: "HotelType",
		components: {
			BaseInput,
			BaseMultiSelect,
		},
		props: {
			count: { type: Number, default: 0 },
			defaultData: { type: [Object, String] },
		},
		emits: ["removeComponent", "updateData"],
		setup: (props, { emit }) => {
			const data = reactive({
				type: null,
				price: 0,
				capacity: 2,
			});

			if (props.defaultData instanceof Object) {
				console.log("defaultData:", props.defaultData);
				let keys = Object.keys(data);

				keys.map((key) => {
					data[key] = props.defaultData[key] || data[key];
				});
			}

			watch(
				() => data,
				(preValue, newValue) => {
					if (data.type && data.price && data.capacity) {
						emit("updateData", { index: props.count, data });
					}
				},
				{ deep: true },
			);

			const multiSelectState = reactive({
				roomTypes: Helper.roomTypes,
			});

			const setRoomType = (payload) => {
				data.type = payload;
			};

			const inputError = (input) => {};
			const inputSuccess = (input) => {};

			return {
				data,
				multiSelectState,

				setRoomType,

				inputError,
				inputSuccess,
			};
		},
	};
</script>
